import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component';
import { selectError, selectLoading } from '../../../redux/features/features.selectors';
import { editDipendente } from '../../../redux/features/dipendenti/dipendenti.thunk';

import './edit-dipendente.styles.scss';
import FormDipendenti from '../../../components/form-dipendenti/form-dipendenti.component';
import { toast } from 'react-toastify';
import { useGetDipendenteQuery } from '../../../redux/features/features.query';

const EditDipendente = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { id } = useParams();
	const loading = useSelector(selectLoading);
	const error = useSelector(selectError);
	const { data, isFetching, isSuccess } = useGetDipendenteQuery(id, { refetchOnMountOrArgChange: true });

	//console.log(isFetching);

	const [campi, setCampi] = useState({
		id: id,
		cognome: '',
		nome: '',
		nascita: '',
		codice_fiscale: '',
		telefono: '',
		mail: '',
		id_mansione: '',
		id_contratto: '',
		data_assunzione: '',
		note: '',
		attivo: ''
	});

	const [errori, setErrori] = useState({
		cognome: false,
		nome: false
	});


	const handleChange = (e) => {
		const { value, name } = e.target;
		setCampi({ ...campi, [name]: value });
		setErrori({ cognome: false, nome: false});
	}

	const inviaDati = async (e) => {
		e.preventDefault();

		if (campi.cognome === '') return setErrori({ ...errori, cognome: true });
		if (campi.nome === '') return setErrori({ ...errori, nome: true });

		const result = await dispatch(editDipendente(campi));

		if (!result.error) {
			toast.success('Dipendente modificato con successo', {
				position: 'top-right'
			})
			navigate('/dipendenti');
		} else {
			toast.error(result.payload, {
				position: 'top-right'
			})
		}
	}

	useEffect(() => {
		if (isSuccess) {
			setCampi(data.dipendente);
		}
	}, [data, isSuccess]);

	return (loading || isFetching) ? (
		<div className='attendere'>
			<Loader />
		</div>
	) : (
		<div className="edit-dipendente">
			<div className="row">
				<div className="col-lg-12">
					<div className="card">
						<div className="card-body">


							<p className="text-primary font-14"><strong>Modifica i Dati del dipendente</strong></p>
							<hr />
							{
								(error) ?
									(<div className="alert alert-danger" role="alert">
										{error}
									</div>)
									: null
							}
							<FormDipendenti errori={errori} handleChange={handleChange} {...campi} inviaDati={inviaDati} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EditDipendente;
